// types
import { ISP_Cabinet } from './types'
// components
import { CabinetIcon } from './CabinetIcon';
import { OperatorPanelWrapperWithChildren } from '../../components/Layout';
import { useGetObjectsChildren } from '../../../hooks/useGetObjectsChildren';
import { useStyletron } from 'baseui';


export function OperatorPanel(props: ISP_Cabinet) {
    const [, theme] = useStyletron()
    const { children: childElement, isLoading, isSuccess, error } = useGetObjectsChildren(props.resourceGroupId, props.id)
    //const temperature1 = childElement?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.TemperatureSensor");
    const ack = childElement?.find((v: any) => v.schema === "AutomationApps.Devices.Commons.Acknowledge");

    return (
        <OperatorPanelWrapperWithChildren resourceGroupId={props.resourceGroupId} objectId={props.id}
            statusContent={<CabinetIcon width="120px" error={ack?.isErr} color={theme.colors.primary}></CabinetIcon>}  >
        </OperatorPanelWrapperWithChildren>
    );
}

